/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type PhoneCallTaskCreatePriority = typeof PhoneCallTaskCreatePriority[keyof typeof PhoneCallTaskCreatePriority];


export const PhoneCallTaskCreatePriority = {
  urgent: 'urgent',
  high: 'high',
  medium: 'medium',
  low: 'low',
} as const;
